module.exports = __webpack_public_path__ + "967522eb2cc5e23d6da9f047db5c1e94.svg";